const translations = {
    pageNumber: 'Page {{pageNumber}}'
};

export default translations;
